export var Route;
(function (Route) {
    Route["Agent"] = "/agents/:agentId";
    Route["Agents"] = "/agents";
    Route["AgentsCounts"] = "/agents/counts";
    Route["AgentStates"] = "/agents/states";
    Route["AnomalyEvents"] = "/anomalies/:anomalyId/anomaly-events";
    Route["Anomalies"] = "/anomalies";
    Route["AnomaliesTrendingPhrasesVariances"] = "/anomalies/:anomalyId/trending-phrases/variances";
    Route["Anomaly"] = "/anomalies/:anomalyId";
    Route["Client"] = "/clients/:clientId";
    Route["InteractionDetails"] = "/interactions/:interactionId/details";
    Route["InteractionMetrics"] = "/interactions/:interactionId/metrics";
    Route["InteractionMetricsAvailable"] = "/interaction-metrics/available";
    Route["InteractionMetricsDistributions"] = "/interaction-metrics/distribution";
    Route["InteractionMetricsSummaries"] = "/interaction-metrics/summaries";
    Route["InteractionMessages"] = "/interactions/:interactionId/messages";
    Route["InteractionMessagesWritingIssues"] = "/interactions/:interactionId/messages/writing-issues";
    Route["InteractionTags"] = "/interactions/:interactionId/tags";
    Route["InteractionVariablesValues"] = "/interactions/:interactionId/variables/values";
    Route["Interactions"] = "/interactions";
    Route["InteractionsCounts"] = "/interactions/counts";
    Route["InteractionsMessage"] = "/interactions/messages/:interactionMessageId";
    Route["InteractionsMessages"] = "/interactions/messages";
    Route["InteractionsMessagesCounts"] = "/interactions/messages/counts";
    Route["Languages"] = "/languages";
    Route["MetabaseDashboards"] = "/metabase-dashboards";
    Route["MetabaseTokens"] = "/metabase-dashboards/:metabaseDashboardId/tokens";
    Route["MetricModelOutputs"] = "/models/:modelId/outputs";
    Route["Model"] = "/models/:modelId";
    Route["Models"] = "/models";
    Route["ModelSubscriptions"] = "/models/:modelId/users";
    Route["Permissions"] = "/permissions";
    Route["PhraseTrigger"] = "/phrase-triggers/:phraseTriggerId";
    Route["PhraseTriggers"] = "/phrase-triggers";
    Route["PhraseTriggersSamples"] = "/phrase-triggers/samples";
    Route["PhraseTriggersResult"] = "/phrase-triggers/results/:phraseTriggerResultId";
    Route["PhraseTriggersResults"] = "/phrase-triggers/results";
    Route["Role"] = "/roles/:roleId";
    Route["Roles"] = "/roles";
    Route["RolePermission"] = "/roles/:roleId/permissions/:permissionId";
    Route["RolePermissions"] = "/roles/:roleId/permissions";
    Route["SpellingExemption"] = "/spelling-exemptions/:spellingExemptionId";
    Route["SpellingExemptions"] = "/spelling-exemptions";
    Route["Tag"] = "/tags/:tagId";
    Route["Tags"] = "/tags";
    Route["TagsAgents"] = "/tags/:tagId/agents";
    Route["TagGroup"] = "/tag-groups/:tagGroupId";
    Route["TagGroups"] = "/tag-groups";
    Route["TagGroupInteractionsVariances"] = "/tag-groups/:tagGroupId/interactions/variances";
    Route["TagModels"] = "/tag-models";
    Route["TimeZones"] = "/time-zones";
    Route["Tokens"] = "/tokens";
    Route["TokensRefresh"] = "/tokens/refresh";
    Route["Translations"] = "/translations";
    Route["User"] = "/users/:userId";
    Route["UserInvite"] = "/users/:userId/invites";
    Route["UserSubscribe"] = "/users/:userId/models";
    Route["UserUnsubscribe"] = "/users/:userId/models/:modelId";
    Route["Users"] = "/users";
    Route["UsersMe"] = "/users/me";
    Route["UsersClients"] = "/users/me/clients";
    Route["WritingIssues"] = "/writing-issues";
    Route["WritingIssuesCounts"] = "/writing-issues/counts";
})(Route || (Route = {}));
//# sourceMappingURL=route.js.map